module.exports = __webpack_public_path__ + "img/p43.9d335e7d.svg";